import React from "react";
import {
  FormControl,
  TextField,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from "app/pages/components/mui/Accordions/StyledAccordion/StyleAccordion";

const ProblemDetails = ({ problemData, handleChange, expanded, onChange }) => {
  return (
    <AccordionStyled expanded={expanded} onChange={onChange} defaultExpanded>
      <AccordionSummaryStyled
        expandIcon={<ExpandMoreIcon />}
        sx={{ display: "flex", alignItems: "center"}}
      >
        <Typography variant="subtitle1">Details</Typography>
      </AccordionSummaryStyled>
      <AccordionDetailsStyled>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            required
            name="name"
            label="Problem Name"
            placeholder="Enter problem name"
            value={problemData.name}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <TextField
            required
            name="defaultTitle"
            label="Default Title"
            placeholder="Enter default title"
            value={problemData.defaultTitle}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            required
            name="description"
            label="Description"
            multiline
            rows={4}
            placeholder="Enter description"
            value={problemData.description}
            onChange={handleChange}
          />
        </FormControl>
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                name="forPaidOnly"
                checked={problemData.forPaidOnly}
                onChange={handleChange}
              />
            }
            label="For Paid Users Only"
          />
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={problemData.status}
              onChange={handleChange}
              label="Status"
            >
              <MenuItem value="ACTIVE">Active</MenuItem>
              <MenuItem value="INACTIVE">Inactive</MenuItem>
              <MenuItem value="REVIEW">Review</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </AccordionDetailsStyled>
    </AccordionStyled>
  );
};

export default ProblemDetails;
